import {Component, NgZone, OnInit} from '@angular/core';

@Component({
  selector: 'mbnm-zoom-dialog',
  templateUrl: './zoom-dialog.component.html',
  styleUrls: ['./zoom-dialog.component.scss']
})
export class ZoomDialogComponent implements OnInit {

  public imageUrl;
  public imageLoaded;
  constructor(private zone: NgZone) { }

  ngOnInit(): void {
  }
}
